import React, { useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link } from 'react-router-dom'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import kucni from '../../img/kucni.jpg'
import kucniPersone from '../../img/kucniPersone.jpg'
import kucniFlow from '../../img/kucniFlow.jpg'
import kucniScr1 from '../../img/kucniScr1.jpg'
import kucniScr2 from '../../img/kucniScr2.jpg'
import kucniScr3 from '../../img/kucniScr3.jpg'
import kucniJourney from '../../img/kucniJourney.jpg'

function Kucni() {
  const { t } = useTranslation();
  const kucniLoFi = "https://www.figma.com/proto/sLV1XlCvhFXpnSvQpWQkj1/Shop?page-id=2%3A16&node-id=2612-1146&viewport=395%2C247%2C0.13&t=nSH0cukZyMwLkYIP-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2612%3A1146";
  const kucniHiFi = "https://www.figma.com/proto/sLV1XlCvhFXpnSvQpWQkj1/Shop?page-id=2%3A16&node-id=2604-1313&viewport=395%2C247%2C0.13&t=Dent2vc25OQkEgOw-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2604%3A1313";
 
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className='container'>
      <MainTitle title={t('kucniTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>Persona</h2>
        <p>{t('kucniPersonaTxt')}</p>
        <figure>
          <img className="image-fluid" src={kucniPersone} alt="Persone" />
          <figcaption>{t('kucniPersonaCaption')}</figcaption>
        </figure>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('UJ')}</h2>
        <p>{t('kucniUJTxt')}</p>
        <figure>
          <img className="image-fluid" src={kucniJourney} alt="User flow" />
          <figcaption>{t('kucniUJCaption')}</figcaption>
        </figure>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('kucniFlowTitle')}</h2>
        <p>{t('kucniFlowTxt')}</p>
        <figure>
          <img className="image-fluid" src={kucniFlow} alt="User flow" />
          <figcaption>{t('kucniFlowCaption')}</figcaption>
        </figure>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('wireframesLF')}</h2>
        <p>{t('kucniLFTxt')}</p>
        <iframe id="kucniLFPrototype" title="kucniLFPrototype" style={{border: "1px solid rgba(0, 0, 0, 0.1)"}} width="100%" height="650" src="https://embed.figma.com/proto/sLV1XlCvhFXpnSvQpWQkj1/Shop?page-id=2%3A16&node-id=2612-1146&viewport=395%2C247%2C0.13&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2612%3A1146&embed-host=share" allowfullscreen></iframe>
        <Link className="btn btn-link btn-inner" to={kucniLoFi} target="_blank">{t('seeLFPrototype')}</Link>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designHF')}</h2>
        <p>{t('bakeryHFTxt')}</p>
        <Tabs className="tabContainer">
          <TabList>
          <Tab>Scr1</Tab>
          <Tab>Scr2</Tab>
          <Tab>Scr3</Tab>
          </TabList>

          <TabPanel>
              <div>
                  <img className='image-fluid' src={kucniScr1} alt="Hi-Fi mockups" />
              </div>
          </TabPanel>
          <TabPanel>
              <div>
                  <img className='image-fluid' src={kucniScr2} alt="Hi-Fi mockups" />
              </div>
          </TabPanel>
          <TabPanel>
              <div>
                  <img className='image-fluid' src={kucniScr3} alt="Hi-Fi mockups" />
              </div>
          </TabPanel>
        </Tabs>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('UT')}</h2>
        <p>{t('kucniUTTxt')}</p>
        <iframe id="kucniHFPrototype" title="kucniHFPrototype" style={{border: "1px solid rgba(0, 0, 0, 0.1)"}} width="100%" height="650" src="https://embed.figma.com/proto/sLV1XlCvhFXpnSvQpWQkj1/Ku%C4%87ni-red?page-id=2%3A16&node-id=2604-1313&viewport=395%2C247%2C0.13&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2604%3A1313&embed-host=share" allowfullscreen></iframe>
        <Link className="btn btn-link btn-inner" to={kucniHiFi} target="_blank">{t('seeHFPrototype')}</Link>
      </div>
    </div>
  )
}

export default Kucni

function ContentOne() {
  const { t } = useTranslation();

  return(
    <img className="image-fluid" src={kucni} alt={t('dsTitle')} />
  );
}

function ContentTwo() {
  const { t } = useTranslation();
  const kucniPrototype = "https://www.figma.com/proto/sLV1XlCvhFXpnSvQpWQkj1/Shop?page-id=2%3A16&node-id=2604-1313&viewport=395%2C247%2C0.13&t=Dent2vc25OQkEgOw-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2604%3A1313";

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('kucniMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={kucniPrototype} target="_blank">{t('seePrototype')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
       <p className='problem'><Trans i18nKey="kucniMainText2">
        The main problem to solve was: <br/><i>How to help household members to share their household tasks without stress and complaints.</i>
      </Trans></p>
    </div>
  );
}